// Props that should not be forwarded to the HTML DOM elements
export var shouldForwardProp = function shouldForwardProp(prop, defaultValidationFn) {
  return !['height', 'width', 'color', 'display', 'cursor'].includes(prop) && defaultValidationFn(prop);
};